export enum PetitionerType {
  SEAT = 'SEAT_EMPLOYEE',
  EXT = 'EXTERNAL',
  FAM = 'FAMILIAR'
}
